import { Inject, Injectable } from '@angular/core';
import { GoogleTagManagerService } from '@shared/api/google-tag-manager.service';
import { WINDOW } from '@ess-front/shared/tokens';
import { ReactNativeService } from '@shared/domain/react-native.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerDomainService {
  private readonly ALLOW_TRACKING_PARAM_NAME = 'allow_tracking';

  constructor(
    @Inject(WINDOW) private window: Window,
    private googleTagManagerService: GoogleTagManagerService,
    private reactNativeService: ReactNativeService,
  ) {
    this.init();
  }

  private init(): void {
    if (this.shouldInitGtm()) {
      this.googleTagManagerService.init();
    }
  }

  private shouldInitGtm(): boolean {
    const hostname = this.window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isStage = hostname.includes('stage');

    // Don't init on localhost or stage
    if (isLocalhost || isStage) {
      return false;
    }

    // If running in mobile WebView, check for tracking consent
    if (this.reactNativeService.isApp()) {
      return this.hasTrackingConsent();
    }

    // For web, init GTM
    return true;
  }

  private hasTrackingConsent(): boolean {
    const urlParams = new URLSearchParams(this.window.location.search);
    const isTrackingAllowed = urlParams.get(this.ALLOW_TRACKING_PARAM_NAME);
    return isTrackingAllowed === 'true';
  }
}
